<template>
    <div>
        <p class="tip">您所要访问的页面不存在或已删除，点击这里返回首页。</p>
        <p class="tip">The page you are visiting does not exist, click HERE back to homepage. </p>
        <el-button @click="toIndex" type="primary">HERE</el-button>
    </div>
</template>
<script>
export default {
    methods: {
        toIndex () {
            this.$router.push('/index')
        }
    }
}
</script>

<style scoped>
.tip {
    font-family: Arial, Helvetica, sans-serif;
    padding-top: 40px;
    font-size: 20px;
}
.el-button {
    margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/client/pages/NotFound.vue